import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type RejectSuggestionsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.RejectSuggestionsInput;
}>;

export type RejectSuggestionsMutationResult = { __typename?: 'Mutation' } & {
  rejectSuggestions?: GraphQLTypes.Maybe<
    { __typename?: 'RejectSuggestionsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const RejectSuggestionsDocument = gql`
  mutation rejectSuggestions($input: RejectSuggestionsInput!) {
    rejectSuggestions(input: $input) {
      errors {
        message
      }
    }
  }
`;
